import React from 'react';
import IconRoblox from '@intelligence/assets/svg/icon-roblox.svg';
import './index.scss';

interface IRobloxPageTitleProps {
  title: string;
}

const RobloxPageTitle: React.FC<IRobloxPageTitleProps> = ({ title }) => {
  return (
    <span className="dbi-roblox-page-title">
      <img className="dbi-roblox-page-title__icon" src={IconRoblox} alt="" />
      <span className="dbi-roblox-page-title__text">{title}</span>
    </span>
  );
};

export default RobloxPageTitle;
